var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#00B259"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2 12.4625H25.0625V11.5625C25.0625 11.225 24.8375 11 24.5 11H15.3875C15.1625 11 14.825 11.225 14.825 11.5625V12.4625H12.8C11.7875 12.4625 11 13.25 11 14.2625V27.3125C11 28.2125 11.7875 29 12.8 29H27.2C28.2125 29 29 28.2125 29 27.2V14.2625C29 13.25 28.2125 12.4625 27.2 12.4625ZM15.95 12.125H24.05V13.025C24.05 13.3625 23.7125 13.7 23.375 13.7H16.85C16.4 13.5875 15.95 13.25 15.95 12.6875V12.125ZM27.2 27.875C27.5375 27.875 27.875 27.5375 27.875 27.2H27.7625V14.2625C27.7625 13.925 27.425 13.5875 27.0875 13.5875H24.95C24.725 14.2625 24.1625 14.7125 23.375 14.7125H16.85C16.0625 14.7125 15.3875 14.2625 15.05 13.5875H12.8C12.4625 13.5875 12.125 13.925 12.125 14.2625V27.2C12.125 27.65 12.35 27.875 12.8 27.875H27.2Z",
    fill: "#00B259"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.263 17.525L18.8755 23.0375L16.4005 21.125C16.1755 21.0125 15.838 21.0125 15.613 21.2375C15.5005 21.4625 15.5005 21.8 15.7255 22.025L18.538 24.275C18.6505 24.3875 18.763 24.3875 18.8755 24.3875C18.988 24.3875 19.213 24.275 19.3255 24.1625L24.0505 18.2C24.2755 17.975 24.163 17.6375 23.938 17.4125C23.713 17.3 23.3755 17.3 23.263 17.525Z",
    fill: "#00B259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.9f725a6d05ecce21fb5838d5ab1f4012.svg";
export { ForwardRef as ReactComponent };